// 前端路由不認得的網址，交回伺服器判（整頁載入），不要自己演「找不到這個頁面」。
//
// 由來（2026-10-03）：地層 Strata 從 /lab/<年>/ 搬到 /strata/<年>/，伺服器那層的 301 有做也有測；
// 但搜尋結果點擊走 router.push，瀏覽器又拿到快取裡的舊索引 → /zh/lab/2024/#lab-nycu-course 在前端直接被 catch-all 吃掉，顯示 404。
// 舊網址的 301（functions/_middleware.js、public/_redirects）、不在 SPA 裡的靜態頁（/archive/…）、真的不存在的頁——
// 這些只有伺服器知道。前端只要做一件事：不認得就整頁載入，讓伺服器決定。錨點與 query 由瀏覽器原樣帶過 301。
//
// 首次載入（from 是 START_LOCATION）不交回：那一頁本來就是伺服器給的（404.html），再載一次會無限迴圈。
export function handOffUnknownRoute(to, from, { start, assign = url => window.location.assign(url), isBrowser = typeof window !== 'undefined' } = {}) {
  if (!isBrowser || from === start) return true
  assign(to.fullPath)
  return false
}
